import * as schema from "./generated/schema";
import { request } from "@/api";
type CurrentUserPath = schema.paths["/api/users/current"];
type CurrentUserResponse =
  CurrentUserPath["get"]["responses"]["200"]["content"]["application/json"];
export type User = CurrentUserResponse["user"];

export const getCurrentUser = async () => {
  return await request.getUnauthenticated<CurrentUserResponse>(
    "/api/users/current"
  );
};

export const logoutUser = async () => {
  return await request.delete("/api/users/current");
};
